import { useState } from 'react';
import { Button, showToast } from '@attentive-platform/stem-ui';

import { FormContainer } from '../../styled';
import { EmailInput } from '../../uicomponents';
import { fetchApiData } from '../../Utils/ApiCalls';
import { isValidEmail } from '../../Utils/HelperFunctions';
import { PRO_PRICING_CONVERSION_ENDPOINT } from '../../urls';

export const ProPricingConversion = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmitHandler = async () => {
    setLoading(true);
    const { error } = await fetchApiData({
      endpoint: PRO_PRICING_CONVERSION_ENDPOINT,
      data: { email, show_pro_pricing: true }
    });
    if (error) {
      showToast(error, 'error');
    } else {
      showToast('Pro pricing conversion successful', 'success');
    }
    setLoading(false);
  };

  return (
    <FormContainer>
      <div>
        <EmailInput
          name='bu-page-email'
          value={email}
          onChange={(_, value) => {
            setEmail(value);
          }}
        />
      </div>
      <div>
        <Button disabled={!email || !isValidEmail(email)} onClick={onSubmitHandler} loading={loading}>
          Convert to Pro pricing
        </Button>
      </div>
    </FormContainer>
  );
};
